export default __webpack_public_path__ + "static/media/Prabhat.d4e0196f.jpeg";